var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMugHotAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M19.9,10h-.557c.055-.418,.103-.828,.142-1.222,.071-.715-.162-1.428-.641-1.957-.471-.52-1.142-.818-1.842-.818l-14.506-.003h0c-.7,0-1.371,.298-1.842,.818C.175,7.347-.059,8.061,.014,8.775c.33,3.321,1.253,7.732,2.313,9.364,1.165,1.792,3.18,2.861,5.389,2.861h4.067c2.209,0,4.224-1.07,5.389-2.861,.192-.296,.38-.683,.561-1.139h2.168c2.223,0,4.1-1.799,4.1-3.929,0-1.923-1.532-3.071-4.1-3.071Zm-8.117,10H7.716c-1.869,0-3.57-.899-4.551-2.406-.826-1.273-1.794-5.273-2.157-8.918-.043-.434,.098-.867,.388-1.187,.285-.315,.677-.489,1.101-.489h0l14.506,.003c.424,0,.814,.174,1.1,.489,.29,.32,.432,.752,.389,1.187-.363,3.645-1.331,7.644-2.157,8.915-.98,1.507-2.682,2.406-4.551,2.406Zm8.117-4h-1.815c.454-1.435,.843-3.249,1.115-5h.701c1.157,0,3.1,.269,3.1,2.071,0,1.56-1.448,2.929-3.1,2.929ZM9,3.5V.5c0-.276,.224-.5,.5-.5s.5,.224,.5,.5V3.5c0,.276-.224,.5-.5,.5s-.5-.224-.5-.5Zm4,0V.5c0-.276,.224-.5,.5-.5s.5,.224,.5,.5V3.5c0,.276-.224,.5-.5,.5s-.5-.224-.5-.5Zm-8,0V.5c0-.276,.224-.5,.5-.5s.5,.224,.5,.5V3.5c0,.276-.224,.5-.5,.5s-.5-.224-.5-.5Zm14.5,20c0,.276-.224,.5-.5,.5H.5c-.276,0-.5-.224-.5-.5s.224-.5,.5-.5H19c.276,0,.5,.224,.5,.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMugHotAlt);
export default __webpack_public_path__ + "static/media/mug-hot-alt.2d51c2ac90e9e2946e332c5e1e387718.svg";
export { ForwardRef as ReactComponent };